module.exports = __webpack_public_path__ + "images/external_images/img/repco-screenshot-6.png";